import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  LoadingButton,
  Typography
} from '@one-thd/sui-atomic-components';
import { TRACK, SCREENS } from '../../AddToConstants';
import { AddToContext } from '../../AddToContext';
import { triggerAnalytics } from '../../AddToHelpers';

export const IntentsPreviewFooter = ({
  handleAccept,
  loading,
  isProjects,
  setIsAutoResolving
}) => {
  const {
    setScreen,
    previousScreen
  } = useContext(AddToContext);

  const handleAutoResolve = () => {
    setIsAutoResolving(true);
  };

  if (isProjects) {
    return (
      <div className="sui-flex sui-flex-col sui-justify-between sui-gap-2">
        <LoadingButton
          fullWidth
          variant="primary"
          value="Step 3: Save and Review Matches"
          loading={loading}
          onClick={handleAccept}
        >Step 3: Save and Review Matches
        </LoadingButton>
        <Button
          variant="secondary"
          fullWidth
          onClick={() => {
            // 10.4.1 Customize Your List Overlay Exit/Cancel - track when going back via Back button
            triggerAnalytics(TRACK.LIST_BUILDER_CUSTOMIZE_LIST_OVERLAY, {
              screen: SCREENS.GENERATED_LIST_INTENTS_PREVIEW
            });

            // Navigate back to the previous screen, or default to DEFAULT screen if no previous screen
            setScreen(previousScreen || SCREENS.DEFAULT);
          }}
        >Back
        </Button>
      </div>
    );
  }
  return (
    <div className="sui-flex sui-flex-col sui-justify-between sui-gap-2">
      <Typography variant="body-lg" weight="bold">
        How would you like to make product selections for the suggested list above?
      </Typography>
      <div
        className="sui-paper sui-paper-outlined sui-rounded-base
          sui-flex sui-gap-4 sui-flex-row sui-items-center sui-h-full sui-rounded-md sui-p-3"
      >
        <div className="sui-flex sui-overflow-hidden sui-flex-col sui-w-3/4">
          <Typography variant="body-lg" weight="bold">
            I'll choose the products
          </Typography>
          <Typography variant="body-sm">
            Review potential matches and make each selection manually
          </Typography>
        </div>
        <div className="sui-flex sui-overflow-hidden sui-flex-col sui-w-1/4 sui-items-center">
          <LoadingButton
            fullWidth
            variant="primary"
            value="Select"
            loading={loading}
            onClick={() => {
              triggerAnalytics(TRACK.LIST_BUILDER_PREVIEW_LIST_FORK_SELECTION, {
                selection: 'ill-choose'
              });
              handleAccept();
            }}
          >Select
          </LoadingButton>
        </div>
      </div>
      <div
        className="sui-paper sui-paper-outlined sui-rounded-base
          sui-flex sui-gap-4 sui-flex-row sui-items-center sui-h-full sui-rounded-md sui-p-3"
      >
        <div className="sui-flex sui-overflow-hidden sui-flex-col sui-w-3/4">
          <Typography variant="body-lg" weight="bold">
            Choose for me
          </Typography>
          <Typography variant="body-sm">
            Automatically match suggested list with products
          </Typography>
        </div>
        <div className="sui-flex sui-overflow-hidden sui-flex-col sui-w-1/4 sui-items-center">
          <Button
            fullWidth
            variant="primary"
            value="Select"
            onClick={() => {
              triggerAnalytics(TRACK.LIST_BUILDER_PREVIEW_LIST_FORK_SELECTION, {
                selection: 'choose-for-me'
              });
              handleAutoResolve();
            }}
          >Select
          </Button>
        </div>
      </div>
    </div>
  );

};

IntentsPreviewFooter.propTypes = {
  handleAccept: PropTypes.func.isRequired
};

IntentsPreviewFooter.displayName = 'IntentsPreviewFooter';
